export const filterCategories = {
  usageDrop: "Usage Drop",
  readyForExpansion: "Ready for Expansion",
  prepareForRenewal: "Prepare for Renewal",
  invoiceOverdue: "Invoice Overdue",
  ai: "AI",
};

// Ordered list for rendering categories in the correct order
export const filterCategoryOrder = [
  "usageDrop",
  "readyForExpansion",
  "prepareForRenewal",
  "invoiceOverdue",
  "ai",
];

export const usageDropCustomerFilters = {
  consumptionUsageDrop: "usage_drop_consumption",
  featureUsageDrop: "usage_drop_feature",
  loginFrequencyDrop: "usage_drop_login_frequency",
};

export const readyForExpansionCustomerFilters = {
  consumption: "ready_for_expansion_consumption",
  featuresAccounts: "ready_for_expansion_features_accounts",
  organisational: "ready_for_expansion_organisational",
};

export const prepareForRenewalCustomerFilters = {
  potentialExpansion: "prepare_for_renewal_potential_expansion",
  potentialDownscale: "prepare_for_renewal_potential_downscale",
  retention: "prepare_for_renewal_retention",
};

export const invoiceOverdueCustomerFilters = {
  invoiceOverdue: "invoice_overdue",
};

export const aiCustomerFilters = {
  churnRisk: "ai_churn_risk",
  expansionOpportunity: "ai_expansion_opportunity",
};

export const customerFilters = {
  // Usage Drop
  [usageDropCustomerFilters.consumptionUsageDrop]: {
    category: filterCategories.usageDrop,
    name: "Consumption usage drop",
    queryKey: "has_consumption_usage_drop",
    queryVal: "true",
    filterKey: usageDropCustomerFilters.consumptionUsageDrop,
  },
  [usageDropCustomerFilters.featureUsageDrop]: {
    category: filterCategories.usageDrop,
    name: "Feature usage drop",
    queryKey: "has_feature_usage_drop",
    queryVal: "true",
    filterKey: usageDropCustomerFilters.featureUsageDrop,
  },
  [usageDropCustomerFilters.loginFrequencyDrop]: {
    category: filterCategories.usageDrop,
    name: "Log in frequency drop",
    queryKey: "has_login_frequency_drop",
    queryVal: "true",
    filterKey: usageDropCustomerFilters.loginFrequencyDrop,
  },
  // Ready for Expansion
  [readyForExpansionCustomerFilters.consumption]: {
    category: filterCategories.readyForExpansion,
    name: "Consumption",
    queryKey: "has_consumption_limit_reached",
    queryVal: "true",
    filterKey: readyForExpansionCustomerFilters.consumption,
  },
  [readyForExpansionCustomerFilters.featuresAccounts]: {
    category: filterCategories.readyForExpansion,
    name: "Features & accounts",
    queryKey: "has_expansion_opportunity",
    queryVal: "true",
    filterKey: readyForExpansionCustomerFilters.featuresAccounts,
  },
  [readyForExpansionCustomerFilters.organisational]: {
    category: filterCategories.readyForExpansion,
    name: "Organisational",
    queryKey: "has_organizational_expansion",
    queryVal: "true",
    filterKey: readyForExpansionCustomerFilters.organisational,
  },
  // Prepare for Renewal
  [prepareForRenewalCustomerFilters.potentialExpansion]: {
    category: filterCategories.prepareForRenewal,
    name: "Expansion potential",
    queryKey: "renewal_forecast_expansion",
    queryVal: "true",
    filterKey: prepareForRenewalCustomerFilters.potentialExpansion,
  },
  [prepareForRenewalCustomerFilters.retention]: {
    category: filterCategories.prepareForRenewal,
    name: "Retention",
    queryKey: "renewal_forecast_retention",
    queryVal: "true",
    filterKey: prepareForRenewalCustomerFilters.retention,
  },
  [prepareForRenewalCustomerFilters.potentialDownscale]: {
    category: filterCategories.prepareForRenewal,
    name: "Potential downscale",
    queryKey: "renewal_forecast_downscale",
    queryVal: "true",
    filterKey: prepareForRenewalCustomerFilters.potentialDownscale,
  },
  // Invoice Overdue
  [invoiceOverdueCustomerFilters.invoiceOverdue]: {
    category: filterCategories.invoiceOverdue,
    name: "Recover invoice overdue",
    queryKey: "has_invoice_overdue",
    queryVal: "true",
    filterKey: invoiceOverdueCustomerFilters.invoiceOverdue,
  },
  // AI
  [aiCustomerFilters.churnRisk]: {
    category: filterCategories.ai,
    name: "Churn risk",
    queryKey: "has_ai_churn_risk",
    queryVal: "true",
    filterKey: aiCustomerFilters.churnRisk,
  },
  [aiCustomerFilters.expansionOpportunity]: {
    category: filterCategories.ai,
    name: "Expansion opportunity",
    queryKey: "has_ai_expansion_opportunity",
    queryVal: "true",
    filterKey: aiCustomerFilters.expansionOpportunity,
  },
};
